var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-sliding-popup',{ref:"slidingPopup",attrs:{"title":_vm.title,"width":"1100px"},on:{"close":_vm.closed}},[_c(_vm.component,{ref:"deviceConnectDeviceInfoNode",tag:"component",attrs:{"slot":"content","nodeParams":_vm.nodeParams,"activeTab":_vm.activeTab},slot:"content"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-472c760a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/topologymap/components/popup/ConnectDeviceInfoPopup.vue
// module id = null
// module chunks = 